
export class DeletedBasicEntities {
baselineValues: number[];
baselines: number[];
freedatas: number[];
}

